var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"menu",staticClass:"el-menu",class:{
    [`el-menu--${_vm.mode}`]: _vm.mode,
    [`el-menu--${_vm.type}`]: _vm.type,
    [`is-${_vm.background}`]: _vm.background,
    [`is-borderBottom`]: _vm.noBorderBottom || _vm.hideAllBorders,
    [`is-hide-all-borders`]: _vm.hideAllBorders,
    'el-menu--collapse': _vm.collapse,
    'el-menu--without-submenus': !_vm.hasSubmenus
  },style:({
    height: _vm.computedHeight,
    minHeight: _vm.computedHeight
  })},[_c('ul',{ref:"menubar",staticClass:"el-menu__bar",style:({
      height: _vm.computedHeight,
      minHeight: _vm.computedHeight
    }),attrs:{"role":"menubar"},on:{"scroll":_vm.debouncedOnMenubarScroll}},[_vm._t("default")],2),_vm._v(" "),(_vm.mode === 'horizontal' && _vm.isOverflow)?_c('div',{staticClass:"el-menu__controls",class:{'is-no-gradient': _vm.hideControlGradient},style:({
      height: _vm.computedHeight,
      minHeight: _vm.computedHeight
    })},[_c('el-button',{attrs:{"type":"ghost"},on:{"click":_vm.leftArrowHandleClick}},[_c('el-icon',{attrs:{"name":"i-chevron-left--16"}})],1),_vm._v(" "),_c('div',{staticClass:"el-menu__controls-divider"}),_vm._v(" "),_c('el-button',{attrs:{"type":"ghost"},on:{"click":_vm.rightArrowHandleClick}},[_c('el-icon',{attrs:{"name":"i-chevron-right--16"}})],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }